module.exports = __webpack_public_path__ + "img/merchant.850ea229.svg";